export default {
    route: {
        index: '首页',
        appointment: '预约任务',
        dispatch: '调度管理',
        dispatchOrder: '发车单管理',
        carrierManage: '承运商管控',
        receiptManage: '回单管理',
        equipment: '设备管理',
        passage: '在途管理',
        orderPanel: '订单看板',
        revocationCarrierHistory: '撤回承运商历史'
    }
};